<div class="form-row py-2">
  <span *ngIf="! simple && rolesService.isHabilite(['gestionnaire']) && (modeRendu.enModeSaisie$ | async)">
    <button class="btn btn-style btn-danger mx-1" title="Suppression définitive du questionnaire"
      (click)="cliqueSupprimer()" [disabled]="! (spinnerService.hidden$ | async)">
      <i class="material-icons md-18 mr-1" aria-hidden="true">delete</i> Supprimer
    </button>
  </span>
  <button *ngIf="export && modeRendu.enModeSaisie$ | async"
    class="btn btn-enq btn-warning col-2" title="Version exportable du questionnaire" (click)="modeRendu.imprimerSaisie()"
    [disabled]="! (spinnerService.hidden$ | async)">
    <i class="material-icons md-18 mr-1" aria-hidden="true">print</i> Version exportable
  </button>
  <button *ngIf="modeRendu.enModeSaisie$ | async"
    class="btn btn-enq btn-primary mx-1 col-2 ml-auto" title="Sauvegarder la saisie en cours" (click)="cliqueSauvegarder()"
    [disabled]="! (spinnerService.hidden$ | async)">
    <i class="material-icons md-18 mr-1" aria-hidden="true">save</i> Sauvegarder
  </button>
  <button *ngIf="! simple && rolesService.isHabilite(['gestionnaire']) && (modeRendu.enModeSaisie$ | async)" class="btn btn-enq btn-success mx-1 col-2" title="Validation du questionnaire"
    (click)="cliqueEnvoyer()" [disabled]="formulaire.invalid || ! (spinnerService.hidden$ | async)">
    <i class="material-icons md-18 mr-1" aria-hidden="true">send</i> Valider
  </button>
  <button *ngIf="! simple && ! rolesService.isHabilite(['gestionnaire']) && (modeRendu.enModeSaisie$ | async)" class="btn btn-enq btn-success mx-1 col-2" title="Validation du questionnaire"
    (click)="cliqueEnvoyerStructure()" [disabled]="formulaire.invalid || ! (spinnerService.hidden$ | async)">
    <i class="material-icons md-18 mr-1" aria-hidden="true">send</i> Valider
  </button>
</div>
